import { useState, memo } from "react";
import StyledButton from "../../../shared_components/StyledButton/StyledButton";
import styles from "./AnimationGeneratorForm.module.css";

function AnimationGeneratorForm({ onSubmit, isFormDisabled, isSubmitting }) {
  const [formData, setFormData] = useState({
    style: "",
    prompt: "",
    imageDimension: "1024x720",
    assetName: "",
    seconds: "8",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const nextErrors = {};
    if (!formData.style.trim()) {
      nextErrors.style = "Style is required.";
    }
    if (!formData.assetName.trim()) {
      nextErrors.assetName = "Asset name is required.";
    }
    if (!formData.prompt.trim()) {
      nextErrors.prompt = "Prompt is required.";
    }
    if (!formData.seconds.trim()) {
      nextErrors.seconds = "Duration is required.";
    }
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const isFormValid =
    formData.style.trim() !== "" &&
    formData.assetName.trim() !== "" &&
    formData.prompt.trim() !== "" &&
    formData.seconds.trim() !== "";

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validate()) {
      return;
    }
    onSubmit(formData);
  };

  const generateButtonLabel = (() => {
    if (isSubmitting) {
      return "Submitting...";
    }
    if (isFormDisabled && !isSubmitting) {
      return "In progress...";
    }
    return "Generate Animation";
  })();

  return (
    <div className={styles.leftContainer}>
      <div className={styles.leftblock}>
        <div className={styles.sectionBlock}>
          {/* <h3>Style</h3> */}
          <p>Try out various styles to apply to your animation and explore the possibilities</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.formPosition}>
            <label className={styles.label} htmlFor="animation-style">
              <h3>Style</h3>
            </label>
            <select
              className={styles.select}
              id="animation-style"
              name="style"
              value={formData.style}
              onChange={handleChange}
              disabled={isFormDisabled}
            >
              <option value="">Select style</option>
              <option value="cinematic">Cinematic</option>
              <option value="realistic">Realistic</option>
              <option value="cartoon">Cartoon</option>
              <option value="sketch">Sketch</option>
              <option value="Flat Design">Flat Design</option>
            </select>
            {errors.style ? <p className={styles.errorText}>{errors.style}</p> : null}
          </div>

          <div className={styles.formPosition}>
            <label className={styles.label} htmlFor="animation-asset-name">
              <h3>Asset Name</h3>
            </label>
            <input
              className={styles.assetInput}
              id="animation-asset-name"
              name="assetName"
              type="text"
              value={formData.assetName}
              onChange={handleChange}
              disabled={isFormDisabled}
              placeholder="e.g. future-city-animation"
            />
            {errors.assetName ? (
              <p className={styles.errorText}>{errors.assetName}</p>
            ) : null}
          </div>

          <div className={styles.inputRow}>
            <div className={styles.formPosition}>
              <label className={styles.label} htmlFor="animation-dimension">
                <h3>Dimension</h3>
              </label>
              <select
                className={styles.select}
                id="animation-dimension"
                name="imageDimension"
                value={formData.imageDimension}
                onChange={handleChange}
                disabled={isFormDisabled}
              >
                <option value="1024x720">1024x720</option>
                <option value="720x1024">720x1024</option>
              </select>
            </div>

            <div className={styles.formPosition}>
              <label className={styles.label} htmlFor="animation-seconds">
                <h3>Duration</h3>
              </label>
              <select
                className={styles.select}
                id="animation-seconds"
                name="seconds"
                value={formData.seconds}
                onChange={handleChange}
                disabled={isFormDisabled}
              >
                <option value="4">4 seconds</option>
                <option value="8">8 seconds</option>
                <option value="12">12 seconds</option>
              </select>
              {errors.seconds ? (
                <p className={styles.errorText}>{errors.seconds}</p>
              ) : null}
            </div>
          </div>

          <div className={styles.formPosition}>
            <label className={styles.label} htmlFor="animation-prompt">
              <h3>Prompt</h3>
            </label>
            <p>What animation do you want to see? Insert text in the box to generate animation.</p>
            <textarea
              className={styles.textareaField}
              id="animation-prompt"
              name="prompt"
              rows={8}
              value={formData.prompt}
              onChange={handleChange}
              disabled={isFormDisabled}
              placeholder="Describe the animation you want to generate..."
            />
            {errors.prompt ? <p className={styles.errorText}>{errors.prompt}</p> : null}
          </div>

          <StyledButton
            className={`${styles.styledButton} ${isFormDisabled || !isFormValid ? styles.disabledButton : ""
              }`}
            disabled={isFormDisabled || !isFormValid}
          >
            {generateButtonLabel}
          </StyledButton>
        </form>
      </div>
    </div>
  );
}

export default memo(AnimationGeneratorForm);
